import {
  SET_INSPECTION_AUTOMATION_DATA,
  UPDATE_CURRENT_INSPECTION_AUTOMATION_DATA,
} from '@redux/actions/automationInspection.actions';
import { InspectionAutomationSettings } from '@ts/automationInspection.types';
import { initialInspectionInstructions } from '@constants/campaigns.constants';
import { OpenAIModelType } from 'respona_api/generated/common_pb';

export type InspectionAutomationStateType = {
  data: InspectionAutomationSettings;
};

export const initialState: InspectionAutomationStateType = {
  data: {
    model: OpenAIModelType.GPT_CHEAP,
    instructions: initialInspectionInstructions,
    includeSummaries: true,
  },
};

export default (state: InspectionAutomationStateType = initialState, { type, payload }) => {
  switch (type) {
    case SET_INSPECTION_AUTOMATION_DATA:
      return {
        ...state,
        data: payload,
      };
    case UPDATE_CURRENT_INSPECTION_AUTOMATION_DATA:
      return {
        ...state,
        data: { ...state.data, ...payload },
      };
    default:
      return state;
  }
};
